// extracted by mini-css-extract-plugin
module.exports = {"signup-popup-main":"Main_signup-popup-main__hfVXv"};